/* ==========================================================================
   Rook UI Core — Progress Controller
   Web Component: <rk-progress-element>
   ========================================================================== */

import { RkComponent } from '@rook/component';

class RkProgressElement extends RkComponent {
    static hydration = 'eager';

    #observer = null;

    setup() {
        this.indicator = this.querySelector('.rk-progress__indicator');
        if (!this.indicator) return;

        this.#updateIndicator();

        this.#observer = new MutationObserver((mutations) => {
            for (const m of mutations) {
                if (m.type === 'attributes' &&
                    (m.attributeName === 'data-value' || m.attributeName === 'data-max')) {
                    this.#updateIndicator();
                }
            }
        });
        this.#observer.observe(this, { attributes: true });
    }

    teardown() {
        this.#observer?.disconnect();
        this.#observer = null;
    }

    get value() {
        const val = parseFloat(this.getAttribute('data-value'));
        return isNaN(val) ? 0 : val;
    }

    set value(val) {
        this.setAttribute('data-value', val);
    }

    get max() {
        const m = parseFloat(this.getAttribute('data-max'));
        return (isNaN(m) || m <= 0) ? 100 : m;
    }

    set max(m) {
        this.setAttribute('data-max', m);
    }

    #updateIndicator() {
        let percentage = (this.value / this.max) * 100;
        percentage = Math.max(0, Math.min(100, percentage));

        const progressBar = this.querySelector('[role="progressbar"]');
        if (progressBar) {
            progressBar.setAttribute('aria-valuenow', this.value);
            progressBar.setAttribute('aria-valuemax', this.max);
        }

        this.indicator.style.transform = `translateX(-${100 - percentage}%)`;
    }
}

if (!customElements.get('rk-progress-element')) {
    customElements.define('rk-progress-element', RkProgressElement);
}
